import React from 'react'
import { Row, Col, Section } from 'components/Layout'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const SectionRow = styled(Row)`
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  ${media.lg`
    flex-direction: row;
  `}
`

const SectionTitleCol = styled(Col)`
  ${media.lg`
    width: 60%;
  `}
`

const SectionTitle = styled.h2`
  margin: 6px 0;
  padding-right: 48px;
`

const DisclaimerSlice = () => {
  const sliceContent = {
    title: 'Legal Disclaimer',
    sections: [
      {
        title: 'Information in accordance with Section 5 TMG',
        text: '<p class="p1">SaaS Bricks Consulting GmbH<br/>Torfstraße 19<br/>13353 Berlin<br/>Germany</p',
      },
      {
        title: 'Contact Information',
        text: '<p class="p1">Telephone: 0160 6347856<br/>E-Mail: jonathan@semplates.io</p>',
      },
      {
        title: 'Disclaimer',
        text:
          '<p><b>Accountability for content</b><br>' +
          "The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this matter, please note that we are not obliged to monitor the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity. Our obligations to remove or block the use of information under generally applicable laws remain unaffected this as per §§ 8 to 10 of the Telemedia Act (TMG).<br>" +
          '<br><b>Accountability for Links</b><br>' +
          'Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective link immediately.<br>' +
          '<br><b>Copyright</b><br>' +
          'Our web pages and their contents are subject to German copyright law. Unless expressly permitted by law, every form of utilizing, reproducing or processing works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights. Individual reproductions of a work are only allowed for private use. The materials from these pages are copyrighted and any unauthorized use may violate copyright laws.</br></p>',
      },
    ],
  }

  return (
    <Section>
      <Row>
        <Col>
          <h1>{sliceContent.title}</h1>
        </Col>
      </Row>
      {sliceContent.sections.map((section, idx) => (
        <SectionRow key={idx}>
          <SectionTitleCol>
            <SectionTitle>{section.title}</SectionTitle>
          </SectionTitleCol>
          <Col>
            <div dangerouslySetInnerHTML={{ __html: section.text }} />
          </Col>
        </SectionRow>
      ))}
    </Section>
  )
}

export default DisclaimerSlice
